'use client';
import React, { useState } from 'react';
import AppImage from '@/components/ui/AppImage';
import { Play, Eye, Heart } from 'lucide-react';

const CATEGORIES = [
{ id: 'all', label: 'Все' },
{ id: 'awareness', label: 'Awareness' },
{ id: 'mind', label: 'Mind' },
{ id: 'illusion', label: 'Illusion' },
{ id: 'practice', label: 'Practice' }];


const VIDEOS = [
{
  id: 1,
  title: 'Ты — не твои мысли',
  subtitle: 'Разбираем иллюзию "я"',
  category: 'awareness',
  duration: '7:42',
  views: '124K',
  likes: '8.2K',
  thumbnail: "https://img.rocket.new/generatedImages/rocket_gen_img_14df5b519-1765260901013.png",
  alt: 'Person meditating in soft morning light with eyes closed, peaceful expression',
  featured: true,
  date: '15 марта 2026'
},
{
  id: 2,
  title: 'Тишина между словами',
  subtitle: 'Где живёт настоящее',
  category: 'practice',
  duration: '12:08',
  views: '89K',
  likes: '5.7K',
  thumbnail: "https://images.unsplash.com/photo-1588883406932-8c70b78ccb87",
  alt: 'Misty mountain valley at dawn with fog rolling through pine trees',
  featured: false,
  date: '12 марта 2026'
},
{
  id: 3,
  title: 'Страх — это иллюзия',
  subtitle: 'Почему мы боимся себя',
  category: 'illusion',
  duration: '9:15',
  views: '201K',
  likes: '14.1K',
  thumbnail: "https://images.unsplash.com/photo-1579729433139-5ac95bada0e9",
  alt: 'Man standing alone on empty road at dusk looking toward horizon',
  featured: true,
  date: '10 марта 2026'
},
{
  id: 4,
  title: 'Что такое ум',
  subtitle: 'Инструмент или хозяин?',
  category: 'mind',
  duration: '6:33',
  views: '67K',
  likes: '4.3K',
  thumbnail: "https://img.rocket.new/generatedImages/rocket_gen_img_19f8fe7fc-1772547120162.png",
  alt: 'Abstract neural network visualization with glowing blue nodes',
  featured: false,
  date: '8 марта 2026'
},
{
  id: 5,
  title: 'Практика наблюдателя',
  subtitle: '10 минут в день меняют всё',
  category: 'practice',
  duration: '14:20',
  views: '156K',
  likes: '11.8K',
  thumbnail: "https://images.unsplash.com/photo-1677594333610-3c3a2cbda88f",
  alt: 'Person sitting cross-legged on wooden floor near large window with morning light',
  featured: false,
  date: '5 марта 2026'
},
{
  id: 6,
  title: 'Эго — не враг',
  subtitle: 'Как работать с собой',
  category: 'awareness',
  duration: '8:55',
  views: '93K',
  likes: '6.9K',
  thumbnail: "https://images.unsplash.com/photo-1695390477298-c94e03faa1c5",
  alt: 'Reflection of face in still water creating mirror image',
  featured: false,
  date: '3 марта 2026'
},
{
  id: 7,
  title: 'Матрица убеждений',
  subtitle: 'Откуда берутся ограничения',
  category: 'illusion',
  duration: '11:40',
  views: '178K',
  likes: '13.4K',
  thumbnail: "https://images.unsplash.com/photo-1612487528505-d2338264c821",
  alt: 'Abstract geometric pattern with interlocking circles representing systems',
  featured: false,
  date: '28 февраля 2026'
},
{
  id: 8,
  title: 'Настоящий момент',
  subtitle: 'Единственное что реально',
  category: 'awareness',
  duration: '5:18',
  views: '312K',
  likes: '24.7K',
  thumbnail: "https://images.unsplash.com/photo-1691687797542-8995c3c26197",
  alt: 'Sun rays breaking through forest canopy creating golden light beams',
  featured: true,
  date: '25 февраля 2026'
},
{
  id: 9,
  title: 'Дыхание как практика',
  subtitle: 'Древняя техника в современном мире',
  category: 'practice',
  duration: '18:05',
  views: '44K',
  likes: '3.1K',
  thumbnail: "https://img.rocket.new/generatedImages/rocket_gen_img_1125e445d-1772195188050.png",
  alt: 'Person lying on grass breathing deeply with eyes closed in nature',
  featured: false,
  date: '22 февраля 2026'
},
{
  id: 10,
  title: 'Смерть эго — рождение себя',
  subtitle: 'Трансформация как процесс',
  category: 'mind',
  duration: '16:30',
  views: '88K',
  likes: '7.6K',
  thumbnail: "https://images.unsplash.com/photo-1566221131329-69203834fd2c",
  alt: 'Butterfly emerging from chrysalis in soft natural light',
  featured: false,
  date: '19 февраля 2026'
},
{
  id: 11,
  title: 'Тело — как зеркало',
  subtitle: 'Что говорят ощущения',
  category: 'awareness',
  duration: '10:12',
  views: '71K',
  likes: '5.2K',
  thumbnail: "https://img.rocket.new/generatedImages/rocket_gen_img_1ed0b5e39-1772263188326.png",
  alt: 'Close up of hands in meditative gesture with warm golden lighting',
  featured: false,
  date: '16 февраля 2026'
},
{
  id: 12,
  title: 'Принятие без согласия',
  subtitle: 'Парадокс внутреннего мира',
  category: 'illusion',
  duration: '13:47',
  views: '55K',
  likes: '4.0K',
  thumbnail: "https://images.unsplash.com/photo-1530723446799-f9f5ab44ebe0",
  alt: 'Calm lake surface reflecting cloudy sky in perfect stillness',
  featured: false,
  date: '13 февраля 2026'
}];


export default function VideoGrid() {
  const [activeCategory, setActiveCategory] = useState('all');
  const [hoveredId, setHoveredId] = useState<number | null>(null);

  const filtered = activeCategory === 'all' ?
  VIDEOS :
  VIDEOS?.filter((v) => v?.category === activeCategory);

  return (
    <section id="videos" className="py-24 px-6 lg:px-10 2xl:px-16" style={{ backgroundColor: 'var(--pub-bg)' }}>
      <div className="max-w-screen-2xl mx-auto">

        {/* Section header */}
        <div className="mb-12">
          <p className="text-xs tracking-widest uppercase text-[#7A7060] mb-3" id="categories">Контент</p>
          <h2 className="text-3xl md:text-4xl font-300 text-[#1C1710] mb-8" style={{ fontWeight: 300, letterSpacing: '-0.01em' }}>
            Все видео
          </h2>

          {/* Category filters */}
          <div className="flex flex-wrap gap-2">
            {CATEGORIES?.map((cat) =>
            <button
              key={cat?.id}
              onClick={() => setActiveCategory(cat?.id)}
              className={`category-pill ${activeCategory === cat?.id ? 'active' : ''}`}>
              
                {cat?.label}
              </button>
            )}
          </div>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-4 gap-6">
          {filtered?.map((video) =>
          <article
            key={video?.id}
            className="video-card group"
            onMouseEnter={() => setHoveredId(video?.id)}
            onMouseLeave={() => setHoveredId(null)}>
            
              {/* Thumbnail */}
              <div className="relative aspect-[4/3] overflow-hidden bg-[#E8E0D0]">
                <AppImage
                src={video?.thumbnail}
                alt={video?.alt}
                fill
                className="object-cover transition-transform duration-500 group-hover:scale-105"
                sizes="(max-width: 640px) 100vw, (max-width: 1024px) 50vw, 25vw" />
              

                {/* Overlay on hover */}
                <div className={`absolute inset-0 bg-black/40 flex items-center justify-center transition-opacity duration-300 ${hoveredId === video?.id ? 'opacity-100' : 'opacity-0'}`}>
                  <div className="w-14 h-14 rounded-full bg-white/20 backdrop-blur-sm border border-white/30 flex items-center justify-center">
                    <Play size={20} className="text-white ml-0.5" fill="white" />
                  </div>
                </div>

                {/* Duration badge */}
                <div className="absolute bottom-2 right-2 px-2 py-0.5 rounded bg-black/60 text-white text-xs tabular-nums">
                  {video?.duration}
                </div>

                {/* Featured badge */}
                {video?.featured &&
              <div className="absolute top-2 left-2 px-2 py-0.5 rounded-full text-xs font-500" style={{ background: 'var(--pub-gold)', color: '#fff' }}>
                    Топ
                  </div>
              }
              </div>

              {/* Info */}
              <div className="p-4">
                <div className="flex items-center gap-2 mb-2">
                  <span className="text-xs font-500 px-2 py-0.5 rounded-full capitalize" style={{ background: '#F0EBE0', color: '#7A7060' }}>
                    {video?.category}
                  </span>
                  <span className="text-xs text-[#7A7060]">{video?.date}</span>
                </div>
                <h3 className="text-sm font-600 text-[#1C1710] mb-1 leading-snug" style={{ fontWeight: 600 }}>
                  {video?.title}
                </h3>
                <p className="text-xs text-[#7A7060] mb-3 leading-relaxed">{video?.subtitle}</p>

                <div className="flex items-center gap-4 text-xs text-[#7A7060]">
                  <span className="flex items-center gap-1">
                    <Eye size={12} />
                    {video?.views}
                  </span>
                  <span className="flex items-center gap-1">
                    <Heart size={12} />
                    {video?.likes}
                  </span>
                </div>
              </div>
            </article>
          )}
        </div>

        {/* Load more */}
        <div className="mt-12 text-center">
          <button className="pub-btn-outline">
            Загрузить ещё
          </button>
        </div>
      </div>
    </section>);

}